import { render } from "./blockType.vue?vue&type=template&id=28c9775c&scoped=true"
import script from "./blockType.vue?vue&type=script&lang=js"
export * from "./blockType.vue?vue&type=script&lang=js"

import "./blockType.vue?vue&type=style&index=0&id=28c9775c&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28c9775c"]])

export default __exports__